import { Inject, Injectable, InjectionToken } from "@angular/core";
import { AppConfigService } from "src/app/Service/Configuration/app-config.service";
import CryptoJS from 'crypto-js';

export const BROWSER_SESSION_STORAGE = new InjectionToken<Storage>(
    'Browser Session Storage',
    {
        providedIn: 'root',
        factory: () => sessionStorage
    }
);

@Injectable({
    providedIn: 'root'
})
export class SessionStorageService {

    constructor(
        @Inject(BROWSER_SESSION_STORAGE) public storage: Storage,
        private appConfig: AppConfigService
    ) { }

    public set(key: string, data: string): void {
        if (data != null && data != undefined) {
            this.storage.setItem(
                key,
                CryptoJS.AES.encrypt(data, this.appConfig.setting.pass).toString()
            );
        }
    }

    public get(key: string): string {
        const value = this.storage.getItem(key);

        if (!value) {
            return null;
        }

        try {
            return CryptoJS.AES.decrypt(value, this.appConfig.setting.pass)
                .toString(CryptoJS.enc.Utf8);
        } catch {
            return value;
        }
    }

    public remove(key: string): void {
        this.storage.removeItem(key);
    }

    public clear(): void {
        this.storage.clear();
    }
}